export const AUTH_SCOPES = {
  businessIdentity: 'https://identity.cafler.com/my-identity/Business.Identity',
  businessServices: 'https://identity.cafler.com/my-identity/Business.Services',
} as const;

export const DEFAULT_AUTH_SCOPES: ReadonlyArray<string> = [
  AUTH_SCOPES.businessIdentity,
  AUTH_SCOPES.businessServices,
];

export const PASSWORD_RESET_SCOPES: ReadonlyArray<string> = [
  AUTH_SCOPES.businessIdentity,
];
